<template>
    <div class="pop_overlay_black" v-if="isShow">
        <div class="pop_wrap rsv2_manager_set_pop" style="width: 360px;">
            <div class="pop_title">
                <span class="title">예약금지 반복 옵션</span>
                <button class="mgl_auto" @click="action_ClosePopup">
                    <v-icon large>mdi-close</v-icon>
                </button>
            </div>
            <div class="pop_cont">
                <!-- 선택한 일자 ~ 숨김 / 표시 -->
                <div class="mgb_10" v-if="!isDiffBlockRepeatOption">
                    <label class="radio_wrap">
                        <input type="radio" :value="'current'" v-model="type">
                        <span class="checkmark"></span>
                        선택한 일자의 예약금지에만 적용
                    </label>
                </div>
                <div class="mgb_10">
                    <label class="radio_wrap">
                        <input type="radio" :value="'following'" v-model="type">
                        <span class="checkmark"></span>
                        선택한 일자 및 이후에 반복되는 예약금지에 적용
                    </label>
                </div>
                <div>
                    <label class="radio_wrap">
                        <input type="radio" :value="'all'" v-model="type">
                        <span class="checkmark"></span>
                        반복 설정된 모든 예약금지에 적용
                    </label>
                </div>
            </div>
            <div class="btn_wrap">
                <button class="btn btn_l btn_blue" @click="action_Confirm">확인</button>
            </div>
        </div>
    </div>
</template>

<script>
import { closeBlockRepeatOptionPopup, sheetOverlays } from '../../../sheet-overlays'

export default {
    data() {
        return {
            sheetOverlays,
            type: 'all',
        }
    },
    watch: {
        isDiffBlockRepeatOption: {
            handler: function (newValue) {
                this.type = newValue ? 'following' : 'current'
            }
        }
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowBlockRepeatOptionPopup
        },
        isDiffBlockRepeatOption: function () {
            return this.sheetOverlays.isDiffBlockRepeatOption
        }
    },
    methods: {
        action_ClosePopup() {
            closeBlockRepeatOptionPopup()
        },
        action_Confirm() {
            if (this.sheetOverlays.repeatOptionPopupHandler != undefined) {
                let func = this.sheetOverlays.repeatOptionPopupHandler
                func(this.type)
            }
            this.action_ClosePopup()
        }
    }
}
</script>